
import React from 'react';

interface TypeSelectorProps {
  type: 'income' | 'expense';
  setType: (type: 'income' | 'expense') => void;
}

const TypeSelector: React.FC<TypeSelectorProps> = ({ type, setType }) => {
  return (
    <div className="flex bg-slate-200 dark:bg-slate-800 p-1 rounded-xl shadow-inner">
      <button 
        type="button" 
        onClick={() => setType('expense')} 
        className={`flex-1 py-2.5 rounded-lg text-[8px] font-black uppercase tracking-widest transition-all ${type === 'expense' ? 'bg-white dark:bg-slate-700 text-red-600 shadow-md' : 'text-slate-500 hover:text-slate-700'}`}
      >
        Despesa
      </button>
      <button 
        type="button" 
        onClick={() => setType('income')} 
        className={`flex-1 py-2.5 rounded-lg text-[8px] font-black uppercase tracking-widest transition-all ${type === 'income' ? 'bg-white dark:bg-slate-700 text-emerald-600 shadow-md' : 'text-slate-500 hover:text-slate-700'}`}
      >
        Receita
      </button>
    </div>
  );
};

export default TypeSelector;
